import IdqsTradePage from './IdqsTradePage';
export { IdqsTradePage };
export default IdqsTradePage;
